import apiRequest from "utils/apiRequestWithErrorCode";
import type {
  FileDownloadLink,
  MalwareAction,
  MalwareContent,
  MalwareFile,
  MalwareListParams,
  MalwareRecord,
} from "@dashboard-v3/api";

export const PAGE_SIZE = 20;

export type StatusFilter = "all" | "blocked" | "released";

export function fetchMalwareContents(params: MalwareListParams) {
  const query = new URLSearchParams();
  if (params.search) query.set("search", params.search);
  query.set("limit", String(params.limit ?? PAGE_SIZE));
  query.set("offset", String(params.offset ?? 0));

  return apiRequest<MalwareContent[]>("GET", `/mxhero-shares/malware?${query}`);
}

export function fetchMalwareFiles(checksum: string) {
  return apiRequest<MalwareFile[]>(
    "GET",
    `/mxhero-shares/malware/${checksum}/files`
  );
}

export function applyMalwareActions(
  checksum: string,
  actions: MalwareAction[]
) {
  return apiRequest<MalwareRecord>(
    "PATCH",
    `/mxhero-shares/malware/${checksum}`,
    { actions }
  );
}

export function fetchFileDownloadLink(fileId: string, checksum: string) {
  const query = new URLSearchParams({ fileId, checksum });
  return apiRequest<FileDownloadLink>(
    "GET",
    `/mxhero-shares/files/download-link?${query}`
  );
}

export function isNew(content: MalwareContent) {
  return !content.viewedAt;
}

export function matchesStatus(content: MalwareContent, status: StatusFilter) {
  if (status === "blocked") return !content.allowedToUse;
  if (status === "released") return content.allowedToUse;
  return true;
}

export function shortChecksum(checksum: string) {
  return `${checksum.slice(0, 8)}…${checksum.slice(-6)}`;
}

export function initials(email: string) {
  const [local = ""] = email.split("@");
  const [first = "", second = ""] = local.split(".");
  return `${first.charAt(0)}${second.charAt(0)}`.toUpperCase();
}
